// src/App.js
import React, { useEffect, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import UserRoutes from './routes/UserRoutes';
import SuperAdminRoutes from './routes/SuperAdminRoutes';

// 1) AOS & its styles
import AOS from 'aos';
import 'aos/dist/aos.css';


// 3) Application Context
import { AppProvider, AppContext } from './components/User/AppContext';

export default function App() {
  // initialize AOS once on app mount
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

function AppContent() {
  const { loading, error } = useContext(AppContext);

  // Loading / Error states
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Loading…
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-600">
        Error loading app data.
      </div>
    );
  }

  const hostname = window.location.hostname;
  const isAdmin = hostname.startsWith('admin.') || hostname === 'admin.propxplorer.com';

  return (
    <BrowserRouter>
      {/* Toast notifications */}
      <Toaster position="top-center" />

      {isAdmin ? <SuperAdminRoutes /> : <UserRoutes />}
    </BrowserRouter>
  );
}
